import React, { useEffect, useState } from "react";
import EmailVerificationComponent from "./emailVerificationComponent";
import { BusinessUser, Auth0Service } from "../../services";
import UserService from "../../services/businessUser";
import Utils from "../../utility";
import { useDispatch, useSelector } from "react-redux";
import {
  failureMessageConstant,
  successMessageConstant,
  keyConstants
} from "../../constants";
import {
  firstTimeLoggedIn,
  hideLoader,
  showLoader
} from "../../slices/userSlice";
import history from "../../managers/history";

const EmailVerification = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const email = user?.email;
  const encryptedPassword = user?.password;
  const [counter, setCounter] = useState(30);
  const [resendEnabled, setResendEnabled] = useState(true);
  const { TOKEN } = keyConstants;

  const startCounter = (counter, setCounter, setResendEnabled) => {
    if (counter > 0) {
      setResendEnabled(false);
      const timer = setTimeout(() => {
        setCounter(counter - 1);
        startCounter(counter - 1, setCounter, setResendEnabled);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setResendEnabled(true);
      return () => {};
    }
  };
  const checkBusinessExist = async () => {
    const userEmail = email.toLowerCase();
    try {
      const [error, businessResponse] = await Utils.parseResponse(
        new UserService().checkBusinessExists({ email: userEmail })
      );
      if (businessResponse != null) {
        return businessResponse;
      } else {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const sendVerificationMail = async () => {
    if (!resendEnabled) return;
    try {
      dispatch(showLoader());
      const businessResponse = await checkBusinessExist();
      const requestBody = {
        userId: businessResponse?.userId
      };
      let [err] = await Utils.parseResponse(
        new BusinessUser().sendVerificationMail(requestBody)
      );
      if (err) {
        Utils.failureToastMessage(err?.message);
        return;
      } else {
        startCounter(30, setCounter, setResendEnabled);
        Utils.successToastMessage(successMessageConstant.EMAIL_SENT);
      }
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(hideLoader());
    }
  };

  const signIn = async () => {
    try {
      dispatch(showLoader());
      const password = Utils.decryptPassword(encryptedPassword);
      const token = await new Auth0Service().getToken({
        email,
        password
      });
      Utils.cookieSetItem(TOKEN, token);
      // Sign in using auth0Service
      await new Auth0Service().signIn({ email, password });
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleClickHere = async () => {
    if (email && encryptedPassword) {
      dispatch(firstTimeLoggedIn(true));
      await signIn();
    } else {
      history.push("/");
    }
  };
  useEffect(() => {
    if (!encryptedPassword) {
      history.push("/");
    }
    if (user?.isFirstTimeLoggedIn) {
      Utils.failureToastMessage(failureMessageConstant.EMAIL_NOT_VERIFIED);
    } else {
      startCounter(30, setCounter, setResendEnabled);
    }
  }, []);

  return (
    <EmailVerificationComponent
      sendVerificationMail={sendVerificationMail}
      counter={counter}
      resendEnabled={resendEnabled}
      handleClickHere={handleClickHere}
    />
  );
};

export default EmailVerification;
